/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OtherPayment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function OtherPayment({
  children,
  viewPath = "/DesignSystem/LedgerPaidBy/PaymentMethod/OtherPayment"
  
}) {
let paymentValueData = fromData.useDataFormat({ viewPath,
context: 'payment',
format: fromHelpers.getText,
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 data="payment"
 format="helpers.js getText"
 text={paymentValueData}
/>
{children}
</React.Fragment>)
}